// extracted by mini-css-extract-plugin
export default {"rpmain":"Welcome_rpmain__mERbg","welcomebg":"Welcome_welcomebg__XllTr","bodywelcome":"Welcome_bodywelcome__6+ltp"};